angular.module("noteStatus.components", []).component("noteStatus", {
    templateUrl: "ng/components/noteStatus/noteStatus.view.html",
    bindings: {
        model: "=",
        exportValidityNoteStatus: "&",
        exportTxtValueModal: "&",
        actionSelected: "=",
        nextStepList: "<",
        canApproveOnBehalf: "<",
        canSkip: "<",
        delegatingApprover: "<",
        canGoToCc: "<",
        nextAssignerInfo: "<",
        canEditAccountManager: '<',
        accountManagerName: '<'
    },
    controllerAs: "noteStatusCtrl",
    controller: function NoteStatus(
        FileUploader,
        $configService,
        $rootScope,
        $timeout,
        $financialApiService,
        $simulationService,
        $download,
        $modalService,
        $location
    ) {
        var self = this;

        self.$onInit = function () {
            self.operatoreRif = {
                nome: self.accountManagerName,
                cognome: ""
            }
            self.staticValueActionSelected = self.actionSelected;
            self.lenghtToDocReserved = self.model.leasingData.preventivo.dettaglioDeroga.docAllegatiRiservati.length;
            self.showRestrictedFiles = $configService.getAppConfig().allFunctionalities.includes("DOC_RISERVATI")
            self.disabledForUploadingInProgress = false;
            self.visualProgBar = false;
            self.supportModel = {
                goToCc: {
                    selected: false
                },
                canApproveOnBhelafSelection: {
                    selected: false
                },
                listaAccount: undefined,
                accountSelezionato: undefined,
            }
            self.loadingStatus = {
                uploading: false,
                loading: false
            };

            if (self.model.leasingData.preventivo.dettaglioDeroga.docAllegati && self.model.leasingData.preventivo.dettaglioDeroga.docAllegati.length) {
                self.documentUpload = self.model.leasingData.preventivo.dettaglioDeroga.docAllegati;
            } else {
                self.documentUpload = [];
            }

            if (self.model.leasingData.preventivo.dettaglioDeroga.docAllegatiRiservati && self.model.leasingData.preventivo.dettaglioDeroga.docAllegatiRiservati.length) {
                self.documentReservedUpload = self.model.leasingData.preventivo.dettaglioDeroga.docAllegatiRiservati;
            } else {
                self.documentReservedUpload = [];
            }

            self.dropdown = {
                tipiDocumento: []
            }

            if (!self.model.leasingData.preventivo.dettaglioDeroga.tipoAzione) {
                self.exportValidityNoteStatus({
                    validity: false
                })
            }
            self.model.leasingData.preventivo.dettaglioDeroga.tipoAzione = null;
            self.checkValidty();


        }

        self.$onChanges = function (changes) {
            if (self.nextStepList) {
                var selectedMode = self.nextStepList.find(function (element) {
                    return element.selected == true;
                })
                self.inviaDirettamente = selectedMode;
            }
        }

        self.handleChange = function (type, value) {
            switch (type) {
                case "tipoAzione":
                    if (value != undefined) {
                        self.showDropDown = value;
                    }
                    break;
                case "inviaDirettamente":
                    self.inviaDirettamente = value;
                    self.model.leasingData.preventivo.dettaglioDeroga.selectedNextStep = value;
                    break;
                case "approvazione":
                    self.model.leasingData.preventivo.dettaglioDeroga.approvedOnBehalf = value;
                    if (value) {
                        self.model.leasingData.preventivo.dettaglioDeroga.delegatingApprover = self.delegatingApprover;
                    }
                    break;

            }
            self.checkValidty();
        }



        self.checkValidty = function () {
            if (!self.lenghtToDocReserved) {
                self.lenghtToDocReserved = 1;
            }
            var testCanApproveOnBehalf = true;
            if (self.canApproveOnBehalf && self.supportModel.canApproveOnBhelafSelection.selected) {
                testCanApproveOnBehalf = !!self.model.leasingData.preventivo.dettaglioDeroga.nota ||
                    self.model.leasingData.preventivo.dettaglioDeroga.docAllegatiRiservati.length >= self.lenghtToDocReserved;
                if (testCanApproveOnBehalf) {
                    self.model.workflowInfo.isDerogaCompleted = true;
                    self.model.leasingData.preventivo.dettaglioDeroga.approvedOnBehalf = true;
                    self.model.leasingData.preventivo.dettaglioDeroga.delegatingApprover = self.delegatingApprover;
                } else {
                    self.model.workflowInfo.isDerogaCompleted = null;
                    self.model.leasingData.preventivo.dettaglioDeroga.approvedOnBehalf = null;
                    self.model.leasingData.preventivo.dettaglioDeroga.delegatingApprover = {};
                }
            } else {
                self.model.workflowInfo.isDerogaCompleted = null;
                self.model.leasingData.preventivo.dettaglioDeroga.approvedOnBehalf = null;
                self.model.leasingData.preventivo.dettaglioDeroga.delegatingApprover = {};
            }
            switch (self.model.leasingData.preventivo.dettaglioDeroga.tipoAzione) {
                case "REQUEST_CORRECTION":
                case "CUSTOMER_CARE":
                    if (self.model.leasingData.preventivo.dettaglioDeroga.nota) {
                        self.exportValidityNoteStatus({
                            validity: true && testCanApproveOnBehalf
                        })
                        self.model.workflowInfo.isDerogaCompleted = true;
                    } else {
                        self.exportValidityNoteStatus({
                            validity: false && testCanApproveOnBehalf
                        })
                    }
                    break;
                case "APPROVE":
                case "NEXT":
                    if ((!self.canSkip && !self.inviaDirettamente) ||
                        (self.canSkip && self.inviaDirettamente && !self.inviaDirettamente.withAttach) ||
                        ((self.canSkip && self.inviaDirettamente && self.inviaDirettamente.withAttach || self.canSkip && self.approvedOnBehalf) &&
                            (self.model.leasingData.preventivo.dettaglioDeroga.nota ||
                                self.model.leasingData.preventivo.dettaglioDeroga.docAllegatiRiservati.length > 0))) {
                        self.exportValidityNoteStatus({
                            validity: true && testCanApproveOnBehalf
                        })
                        self.model.workflowInfo.isDerogaCompleted = true;
                    } else {
                        self.exportValidityNoteStatus({
                            validity: false && testCanApproveOnBehalf
                        })
                    }
                    break;
                default:
                    self.exportValidityNoteStatus({
                        validity: false
                    })
                    break;
            }
            self.exportTxtValueModal({
                value: self.model.leasingData.preventivo.dettaglioDeroga.tipoAzione
            })
        }

        self.uploadDataFunc = function (restricted) {
            var document =
                arguments.length > 3 && arguments[3] !== undefined ?
                    arguments[3] :
                    false;

            self.uploadDocumenti = document;
            self.restricted = restricted;

        }

        // istanza di file uploader
        self.uploader = new FileUploader({
            url: "",
            headers: {
                "Access-Control-Allow-Origin": "*",
                Token: "Bearer " + ($configService.getAppConfig().token || "no-token"),
                "App-Name": $rootScope.portalName,
            }
        })

        // questa funzione viene chiamata subito dopo aver selezionato un file per l'upload
        self.uploader.onAfterAddingFile = function (fileItem) {
            if (fileItem.file.size > 26214400) {
                $rootScope.$broadcast("addAlert", {
                    text: "MAXIMUM_FILE_SIZE_EXCEEDED",
                });
                fileItem.remove();
                $("#input-upload-" + self.currentCodeTypeNameIndex).val("");
            }
            var fileName = fileItem.file.name;
            if (
                fileName.toLowerCase().indexOf(".pdf") > -1 ||
                fileName.toLowerCase().indexOf(".png") > -1 ||
                fileName.toLowerCase().indexOf(".jpg") > -1 ||
                fileName.toLowerCase().indexOf(".jpeg") > -1 ||
                fileName.toLowerCase().indexOf(".msg") > -1 ||
                fileName.toLowerCase().indexOf(".eml") > -1 ||
                fileName.toLowerCase().indexOf(".zip") > -1 ||
                fileName.toLowerCase().indexOf(".p7m") > -1
            ) {
                self.visualProgBar = true;
                self.uploader.queue[0].progress = 100;

                $timeout(function () {
                    self.progresso = 100;
                }, 500);
            } else {
                fileItem.remove();
                $("#input-upload-" + self.currentCodeTypeNameIndex).val("");
                $rootScope.$broadcast("addAlert", {
                    text: "FORMAT_NOT_SUPPORTED",
                })
            }
        }

        self.uploader.onAfterAddingAll = function (addedFileItems) {
            self.finalUpload(addedFileItems);
        }

        self.finalUpload = function (file) {
            console.log("calling finalUpload");
            self.folderPath = "" + new Date().getTime();
            var url = $configService.getAppConfig().url +
                "/uni/upload/service-infos/" +
                encodeURIComponent(self.model.anno) +
                "/" +
                encodeURIComponent(self.model.numero) +
                "/FINANCIAL";
            for (var int = 0; int < self.uploader.queue.length; int++) {
                self.uploader.queue[int].url = url;
            }
            self.loadingStatus.uploading = true;

            var file = {}
            if (self.restricted) {
                file = document.querySelector("#uploadInput_document_restrict").files[0];
            } else {
                file = document.querySelector("#uploadInput_document").files[0];
            }
            self.disabledButtonUpload = true;
            var reader = new FileReader();
            reader.onload = function () {
                if (self.restricted) {
                    jQuery("#uploadInput_document_restrict").val("");
                } else {
                    jQuery("#uploadInput_document").val("");
                }
                var formData = new FormData();
                appendToForm(formData, "file", file);
                appendToForm(formData, "type", 'FINANCIAL_DEROGHE');
                appendToForm(formData, "cdDoc", 'GENP');
                appendToForm(formData, "filename", file.name);
                appendToForm(formData, "idPratica", self.model.leasingData.id);
                appendToForm(formData, "category", "DEROGA");
                appendToForm(formData, "restricted", self.restricted);

                $financialApiService.uploadDocOnDigital(formData)
                    .then(function (response) {
                        $timeout(function () {
                            var docAllegato = {
                                id: response.id,
                                cdDoc: "GENP",
                                filename: file.name,
                                restricted: self.restricted,
                                downloadKey: response.downloadKey
                            }
                            if (docAllegato.restricted === true) {
                                self.model.leasingData.preventivo.dettaglioDeroga.docAllegatiRiservati.push(docAllegato);
                                self.documentReservedUpload = self.model.leasingData.preventivo.dettaglioDeroga.docAllegatiRiservati;
                            } else {
                                self.model.leasingData.preventivo.dettaglioDeroga.docAllegati.push(docAllegato);
                                self.documentUpload = self.model.leasingData.preventivo.dettaglioDeroga.docAllegati;
                            }
                            self.visualProgBar = false;
                            self.disabledButtonUpload = false;
                            self.checkValidty();
                        }, 4000);
                    })
                    .catch(function (error) {
                        self.visualProgBar = false;
                        self.disabledButtonUpload = false;
                    })
            };
            if (file) {
                reader.readAsArrayBuffer(file);
            }
            self.checkValidty();
        }

        self.check = function (el) {
            el.selected = !el.selected;
            self.model.leasingData.preventivo.dettaglioDeroga.goToCc = self.supportModel.goToCc.selected;
            if (!self.model.leasingData.preventivo.dettaglioDeroga.goToCc) {
                self.model.leasingData.preventivo.dettaglioDeroga.tipoAzione = "NEXT";
            } else {
                self.model.leasingData.preventivo.dettaglioDeroga.tipoAzione = "CUSTOMER_CARE";
            }

            if (self.supportModel.canApproveOnBhelafSelection.selected) {
                self.actionSelected = 'APPROVE'
                self.model.leasingData.preventivo.dettaglioDeroga.tipoAzione = 'APPROVE'
            } else {
                self.actionSelected = self.staticValueActionSelected
                if (!self.model.leasingData.preventivo.dettaglioDeroga.tipoAzione) {
                    self.model.leasingData.preventivo.dettaglioDeroga.tipoAzione = 'REQUEST_CORRECTION'
                } else {
                    self.model.leasingData.preventivo.dettaglioDeroga.tipoAzione = self.actionSelected;
                }
            }
            self.checkValidty();
        }

        self.trashCanEnabledDoc = function () {
            return self.documentUpload && self.documentUpload.some(function (elem) {
                return elem.selected === true;
            })
        }
        self.trashCanEnabledDocRes = function () {
            return self.documentReservedUpload && self.documentReservedUpload.some(function (elem) {
                return elem.selected === true;
            })
        }

        self.uploader.onCompleteAll = function () {
            self.uploadCompleted = true;
        }

        // funzione per eliminare un documento
        self.deleteDocument = function (restricted) {
            self.restricted = restricted;
            self.progresso = 100;
            self.visualProgBar = true;
            $timeout(function () {
                self.progresso = 0;
            }, 200);

            self.documentsToBeDeleted = self.documentUpload.filter(function (elem) {
                return elem.selected == true;
            })

            self.documentsToBeDeleted.forEach(function (element) {
                $simulationService.deleteChecklistFileDigital(element.id)
                    .then(function () {
                        $timeout(function () {
                            self.visualProgBar = false;
                            self.documentUpload = self.documentUpload
                                .filter(function (e) {
                                    return e.selected != true
                                })
                            self.documentReservedUpload = self.documentReservedUpload
                                .filter(function (e) {
                                    return e.selected != true
                                })
                            if (self.restricted) {
                                self.lenghtToDocReserved--;
                            }
                            self.model.leasingData.preventivo.dettaglioDeroga.docAllegati = self.documentUpload;
                            self.model.leasingData.preventivo.dettaglioDeroga.docAllegatiRiservati = self.documentReservedUpload;
                        }, 4000);

                    })
                    .catch(function () {
                        $rootScope.$broadcast('addAlert', {
                            text: 'ERROR_TEC'
                        });

                    })
            })
            self.documentsResToBeDeleted = self.documentReservedUpload.filter(function (elem) {
                return elem.selected == true;
            })
            self.documentsResToBeDeleted.forEach(function (element) {
                $simulationService.deleteChecklistFileDigital(element.id)
                    .then(function () {
                        $timeout(function () {
                            self.visualProgBar = false;
                            self.documentReservedUpload = self.documentReservedUpload
                                .filter(function (e) {
                                    return e.selected != true
                                })
                            self.model.leasingData.preventivo.dettaglioDeroga.docAllegatiRiservati = self.documentReservedUpload;
                            self.checkValidty();
                        }, 4000);

                    })
                    .catch(function () {
                        $rootScope.$broadcast('addAlert', {
                            text: 'ERROR_TEC'
                        });

                    })
            })

        }

        self.checkSelected = function (el) {
            el.approvedOnBehalf = !el.approvedOnBehalf;
            self.checkValidty();
        };

        self.downloadFile = function (file) {
            var url = "/uni/downloadDocDigital/service-infos/"
            var input = {
                downloadKey: file.downloadKey
            }
            $download.getGenericDownload(url, input)
                .then(function (response) {
                    console.log(response)
                })

        }

        self.openModal = function () {
            $modalService.openModal("changeAccRif-modal");
            self.getAccountList();
        }

        self.closeModal = function () {
            $modalService.closeModal("changeAccRif-modal");
        }

        self.changeDropdown = function () {
            if (self.supportModel && self.supportModel.accountSelezionato) {
                self.confirmEnabled = true;
            } else {
                self.confirmEnabled = false;
            }
        }

        self.confirmModal = function () {
            self.isSearching = true;
            $financialApiService.setNdgAccount(self.model.leasingData.id, self.supportModel.accountSelezionato.ndg)
                .then(function (response) {
                    if (response.success) {
                        self.operatoreRif = self.supportModel.accountSelezionato;
                        $modalService.closeModal("changeAccRif-modal");
                        $location.path('/')
                    }
                })
                .catch(function (err) {
                    console.error(err)
                })
                .finally(function () {
                    self.isSearching = false;
                })
        }

        self.getAccountList = function () {
            $financialApiService.getAccountListGerarchia()
                .then(function (response) {
                    self.supportModel.listaAccount = response;
                })
                .catch(function (error) {
                    console.log(error)
                })
        }
    }
})